import { ApplicationConfig, provideZoneChangeDetection, isDevMode, ErrorHandler, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

// Register French locale data
registerLocaleData(localeFr, 'fr-FR');
import { MSALInstanceFactory, MSALGuardConfigFactory, MSALInterceptorConfigFactory } from './msal.config';
import { MsalService, MsalGuard, MsalBroadcastService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MsalInterceptor, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS, withFetch } from '@angular/common/http';
import { AzureInterceptor } from './interceptors/azure.interceptor';
import { provideMicroSentry } from '@micro-sentry/angular';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { GlobalErrorHandler } from './services/global-error-handler.service';

import { environment } from '@environments/environment';
import { provideServiceWorker } from '@angular/service-worker';

export const appConfig: ApplicationConfig = {
	providers: [
		provideZoneChangeDetection({ eventCoalescing: true }),
		provideRouter(routes),
		provideAnimationsAsync(),
		provideHttpClient(withInterceptorsFromDi(), withFetch()),
		{
			provide: LOCALE_ID,
			useValue: 'fr-FR',
		},
		{
			provide: ErrorHandler,
			useClass: GlobalErrorHandler,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MsalInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AzureInterceptor,
			multi: true,
		},
		{
			provide: MSAL_INSTANCE,
			useFactory: MSALInstanceFactory,
		},
		{
			provide: MSAL_GUARD_CONFIG,
			useFactory: MSALGuardConfigFactory,
		},
		{
			provide: MSAL_INTERCEPTOR_CONFIG,
			useFactory: MSALInterceptorConfigFactory,
		},
		MsalService,
		MsalGuard,
		MsalBroadcastService,
		MatSnackBarModule,
		// provideMicroSentry({
		// 	dsn: "https://0da2d2f3439846a6af6ecba2c0536541@track.tools.hubstack.fr/1",
		// 	environment: environment.environment,
		// 	beforeSend: (event: any) => {
		// 		try {
		// 			// 1) Attach user
		// 			// Prefer the stable 'sentryUser' set at app start from MSAL
		// 			let username: string | undefined;
		// 			const stable = localStorage.getItem('sentryUser');
		// 			if (stable) {
		// 				try {
		// 					const u = JSON.parse(stable);
		// 					username = u?.username || u?.email || u?.name;
		// 				} catch { username = stable; }
		// 			}
		// 			// Fallback: scan a few common/dynamic keys (MSAL stores dynamic keys)
		// 			if (!username) {
		// 				const keys = ['username','userName','user','current_user','msal.active-account','msal.account'];
		// 				for (const k of keys) {
		// 					const raw = localStorage.getItem(k);
		// 					if (!raw) continue;
		// 					try {
		// 						const obj = JSON.parse(raw);
		// 						username = obj?.username || obj?.userName || obj?.name || obj?.displayName || obj?.preferred_username || obj?.email;
		// 					} catch { username = raw; }
		// 					if (username) break;
		// 				}
		// 			}
		// 			// Always tag environment; add username if available
		// 			const baseTags: any = { ...(event.tags || {}), environment: environment.environment };
		// 			if (username) {
		// 				event.user = { username };
		// 				baseTags.username = username;
		// 			}
		// 			event.tags = baseTags;

		// 			// 2) Deep sanitize the entire event to avoid Blob/File and similar
		// 			const seen = new WeakSet<object>();
		// 			const isBinary = (v: any) => v instanceof Blob || v instanceof File || v instanceof ArrayBuffer || ArrayBuffer.isView(v);
		// 			const isHostObj = (v: any) => typeof Event !== 'undefined' && v instanceof Event
		// 				|| typeof FileList !== 'undefined' && v instanceof FileList
		// 				|| typeof DataTransfer !== 'undefined' && v instanceof DataTransfer
		// 				|| typeof ReadableStream !== 'undefined' && v instanceof ReadableStream
		// 				|| typeof Request !== 'undefined' && v instanceof Request
		// 				|| typeof Response !== 'undefined' && v instanceof Response;
		// 			const deepSanitize = (value: any, depth = 0): any => {
		// 				if (value == null) return value;
		// 				const t = typeof value;
		// 				if (t === 'function') return undefined;
		// 				if (t !== 'object') {
		// 					if (t === 'string' && value.length > 30000) return value.slice(0, 30000) + '…';
		// 					return value;
		// 				}
		// 				if (isBinary(value) || isHostObj(value)) {
		// 					try {
		// 						if (value instanceof Blob || value instanceof File) return `[Blob ${value.type || 'application/octet-stream'} size=${value.size}]`;
		// 						if (value instanceof ArrayBuffer) return `[Binary ${value.byteLength} bytes]`;
		// 						if (ArrayBuffer.isView(value)) return `[Binary ${value.byteLength} bytes]`;
		// 						if (typeof FileList !== 'undefined' && value instanceof FileList) return `[FileList ${value.length}]`;
		// 						if (typeof DataTransfer !== 'undefined' && value instanceof DataTransfer) return `[DataTransfer items=${value.items?.length || 0}]`;
		// 						if (typeof Event !== 'undefined' && value instanceof Event) return `[Event ${value.type}]`;
		// 						return '[HostObject]';
		// 					} catch { return '[Binary]'; }
		// 				}
		// 				if (seen.has(value)) return '[Circular]';
		// 				seen.add(value);
		// 				if (depth > 5) return '[Truncated]';
		// 				if (Array.isArray(value)) {
		// 					return value.slice(0, 200).map((v) => deepSanitize(v, depth + 1));
		// 				}
		// 				// Plain object
		// 				const out: any = {};
		// 				const entries = Object.entries(value).slice(0, 100);
		// 				for (const [k, v] of entries) {
		// 					// Heuristic: keys that often carry blobs
		// 					if (k === 'files' || k === 'file' || k === 'dataTransfer') {
		// 						out[k] = '[Stripped]';
		// 						continue;
		// 					}
		// 					out[k] = deepSanitize(v, depth + 1);
		// 				}
		// 				return out;
		// 			};
		// 			const sanitized = deepSanitize(event);
		// 			// 3) On iOS, strip request and breadcrumbs altogether for robustness
		// 			const ua = (navigator && navigator.userAgent) ? navigator.userAgent : '';
		// 			const isIOS = /iPad|iPhone|iPod/.test(ua) || (ua.includes('Macintosh') && 'ontouchend' in document);
		// 			if (isIOS) {
		// 				if (sanitized && sanitized.request) sanitized.request = undefined;
		// 				if (sanitized && sanitized.breadcrumbs) sanitized.breadcrumbs = undefined;
		// 			}
		// 			return sanitized;
		// 		} catch {}
		// 		return event;
		// 	}
		// }), 
		provideServiceWorker('ngsw-worker.js', {
			// Banc de test local : build sans service worker (et sans cache entre deux builds).
			enabled: !isDevMode() && environment.environment !== 'local',
			registrationStrategy: 'registerImmediately'
		})
	]
};
